export const ErrorAlert = {
  content: `죄송합니다. 찾으려는 페이지의 주소가 잘못 입력되었거나\n주소의 변경 혹은 삭제로 인해 사용하실 수 없습니다.`,
};
